"use client";

import { Button, Text } from "@/components";
import { Modal, ModalBody, ModalFooter } from "@/components/ui";
import { useThemeTokens } from "@/lib/theme/tokens";
import { useInteractiveTokens } from "@/lib/theme/tokens/interactive";

export const DeleteModal = ({
  isOpen,
  onClose,
  onConfirm,
  "data-testid": dataTestId,
}: {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  "data-testid"?: string;
}) => {
  const theme = useThemeTokens();
  const interactive = useInteractiveTokens();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Delete Contact"
      size={{ base: "md", md: "md" }}
      contentProps={dataTestId ? { "data-testid": dataTestId } : undefined}
    >
      <ModalBody py={6}>
        <Text
          as="div"
          fontSize="sm"
          color={theme.text.secondary}
          lineHeight="1.6"
        >
          Are you sure you want to delete this contact? This action cannot be
          undone.
        </Text>
      </ModalBody>

      <ModalFooter
        px={{ base: 4, md: 6 }}
        py={4}
        borderTopWidth="1px"
        borderTopColor={theme.borderGlass.default}
        gap={3}
      >
        <Button
          variant="outline"
          onClick={onClose}
          flex={{ base: "1", sm: "none" }}
          {...(dataTestId
            ? { "data-testid": `${dataTestId}-cancel-button` }
            : {})}
        >
          Cancel
        </Button>

        <Button
          variant="primary"
          onClick={onConfirm}
          flex={{ base: "1", sm: "none" }}
          {...(dataTestId
            ? { "data-testid": `${dataTestId}-confirm-button` }
            : {})}
          bg={theme.accent.primary}
          color="white"
          sx={{
            "@media (hover: hover)": {
              "&:hover": {
                bg: interactive.button.primary.hover,
              },
            },
            "@media (hover: none) and (pointer: coarse)": {
              "&:active": {
                bg: interactive.button.primary.active,
              },
            },
          }}
          _focus={{
            boxShadow: theme.focusRing,
          }}
        >
          Yes, delete
        </Button>
      </ModalFooter>
    </Modal>
  );
};
